import { render, staticRenderFns } from "./LeaderboardRank.vue?vue&type=template&id=1d75db08"
import script from "./LeaderboardRank.vue?vue&type=script&lang=js"
export * from "./LeaderboardRank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports